import React from "react";
import {
  MDBFooter,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBIcon,
} from "mdb-react-ui-kit";
import { Link } from "react-router-dom";

export default function App() {
  return (
    <MDBFooter className="bg-nav2 text-center text-lg-start text-muted">
      <section className="bg-nav2 d-flex justify-content-center justify-content-lg-between p-4 border-bottom">
        <div className="font-arabic text-2xl me-5 d-none d-lg-block">
          <div clasName="">💥 الزق هتغير مودك 💥</div>
        </div>

        <div>
          <a
            href="https://www.facebook.com/share/b1mk7S1YER8UWjtt/?mibextid=wwXIfr"
            className="me-4 text-reset"
            target="_blank"
            rel="noopener noreferrer"
          >
            <MDBIcon color="secondary" fab icon="facebook-f" />
          </a>
          <a
            href="https://www.instagram.com/elza2_eg/profilecard/?igsh=MWNqMHY3bXRtdm1ubg=="
            className="me-4 text-reset"
            target="_blank"
            rel="noopener noreferrer"
          >
            <MDBIcon color="secondary" fab icon="instagram" />
          </a>
          <a
            href="https://www.tiktok.com/@elza2_eg?_t=ZS-8scDaCYsbSx&_r=1"
            className="me-4 text-reset"
            target="_blank"
            rel="noopener noreferrer"
          >
            <MDBIcon color="secondary" fab icon="tiktok" />
          </a>
        </div>
      </section>

      <section className="bg-nav2">
        <MDBContainer className="text-center text-md-start mt-5">
          <MDBRow className="mt-3">
            <MDBCol md="3" lg="4" xl="3" className="mx-auto mb-4">
              <h6 className="text-uppercase fw-bold mb-4">💎 Elza2 ?</h6>
              <p>
                in 2022 we set out to create a lifestyle brand that embodies the
                fun, the trendy, the loud and the crazy. We called it, Elza2.
                With our famous Slogan “هتغير مودك" Because we knew that the
                simplest everyday products have the power to add joy to people’s
                lives.
              </p>
            </MDBCol>

            <MDBCol md="2" lg="2" xl="2" className="mx-auto mb-4">
              <h6 className="text-uppercase fw-bold mb-4">Categories</h6>
              <p>
                <Link
                  to="/products?category=66d3831f1bbba06a86ae9232"
                  className="text-reset"
                >
                  Single Stickers
                </Link>
              </p>
              <p>
                <a
                  href="?category=66d47e52fd17975d3c784cfc"
                  className="text-reset"
                >
                  Keyboard Stickers
                </a>
              </p>
              <p>
                <a
                  href="?category=66eca35dd021a28e1ef99f4f"
                  className="text-reset"
                >
                  Laptop Skin
                </a>
              </p>
              <p>
                <a
                  href="?category=674ee7467b12160bfe507c89"
                  className="text-reset"
                >
                  Mouse Pad
                </a>
              </p>
              <p>
                <a
                  href="/products?category=674f140d652e205d4a2b7166"
                  className="text-reset"
                >
                  Photo card
                </a>
              </p>
              <p>
                <Link
                  to="/products?category=6756bcf081d5dd3ef2738345"
                  className="text-reset"
                >
                  Fridge Magnets
                </Link>
              </p>
              <p>
                <Link
                  to="/products?category=675c41ba713b874acdbe0cf8"
                  className="text-reset"
                >
                  Mugs
                </Link>
              </p>
              <p>
                <Link
                  to="/products?category=675c41ce713b874acdbe0cfb"
                  className="text-reset"
                >
                  Coasters
                </Link>
              </p>
              <p>
                <Link
                  to="/products?category=675c41e0713b874acdbe0cfe"
                  className="text-reset"
                >
                  Key Chains
                </Link>
              </p>
            </MDBCol>

            <MDBCol
              md="4"
              lg="3"
              xl="3"
              className="bg-nav2 mx-auto mb-md-0 mb-4"
            >
              <h6 className="bg-nav2 text-uppercase fw-bold mb-4">Contact</h6>
              <div className="bg-nav2 footer-font ">
                <MDBIcon
                  classNmae="bg-nav2"
                  color="bg-nav2"
                  icon="home"
                  className="me-2"
                />
                Made in Egypt
              </div>
              <p className="footer-font">
                <MDBIcon color="black" icon="envelope" className="me-3" />
                Elza2.eg@gmail.com
              </p>
              <p className="footer-font ">
                <MDBIcon color="black" icon="phone" className="me-3" /> +2
                01090400554
              </p>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </section>

      <div
        className="text-center p-4"
        style={{ backgroundColor: "rgba(0, 0, 0, 0.05)" }}
      >
        © 2024 Copyright:
        <a
          className="text-reset fw-bold"
          href="https://github.com/Abdelrahman0122"
          target="_blank"
          rel="noopener noreferrer"
        >
          Abdelrahman Elsayed
        </a>
        <a
            href="https://www.linkedin.com/in/abdelrahman-elsayed-828736234/"
            className="m-1 text-reset"
            target="_blank"
            rel="noopener noreferrer"
          >
            <MDBIcon color="secondary" fab icon="linkedin" />
          </a>
        
      </div>
    </MDBFooter>
  );
}
